export default function EventGlyph({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M12 3.75a5.75 5.75 0 015.75 5.75c0 4.64-5.75 10.75-5.75 10.75S6.25 14.14 6.25 9.5A5.75 5.75 0 0112 3.75zm0 3a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
        fill="currentColor"
      />
      <circle
        cx="18.25"
        cy="5.75"
        r="1.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        opacity="0.72"
      />
    </svg>
  );
}
